import { Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { SxProps, Theme } from '@mui/material/styles';

interface StepHeaderProps {
    icon: ReactNode;
    title: ReactNode;
    description: ReactNode;
    /** Extra styles for the round icon container (e.g. color / bgcolor / fontSize). */
    circleSx?: SxProps<Theme>;
}

/**
 * Shared header for onboarding steps: a round icon badge followed by a
 * title and a description, all centered.
 */
export const StepHeader = ({ icon, title, description, circleSx }: StepHeaderProps) => (
    <Stack alignItems="center" textAlign="center">
        <Stack
            sx={{
                aspectRatio: 1,
                p: 2,
                borderRadius: '50%',
                justifyContent: 'center',
                alignItems: 'center',
                mb: 1,
                ...circleSx,
            }}
        >
            {icon}
        </Stack>
        <Typography variant="subtitle1" fontSize="large" gutterBottom>
            {title}
        </Typography>
        <Typography variant="body1" gutterBottom>
            {description}
        </Typography>
    </Stack>
);

export default StepHeader;
